import { useStore } from "../../../app/stores/store";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { Button, Icon, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow,Modal, Header, Loader, FormField, Input,  Select, /*Header,Image, ModalActions*/ } from "semantic-ui-react";
import { useEffect, useState,/*useRef*/ } from "react";
import moment from 'moment';
import { toast } from 'react-toastify';
import {dropTitleCode, TitleWiseDashboard} from '../../../app/models/Restoration';
import PCRDownload from '../Report/PCRReport/PCRPdfDownload';
import FrrCreate from '../Report/PCRReport/FRRReportGenerate';
import FRRreport  from '../Report/PCRReport/FRReportPdfconvert';
import PCRCreate from '../Report/PCRReport/PCRReport';
function TitleDashboardReport() {
  const { RestorationStore, PivotStore,userStore: { user }, } = useStore();
  const [loadData, setLoadData] = useState<TitleWiseDashboard[]>([]);
  const [pcrData, setpcrData] = useState<TitleWiseDashboard|null>(null);
  const currentDate = new Date();
  const [reportOptions, setReportOptions] = useState<dropTitleCode[]>([]);
  const [tableLoading,setTableLoading]=useState<boolean>(true);
  const [selectedReportType,setSelectedReportType]=useState<string>('');
  const [titleName,setTitleName]=useState<string>('');
  const [startDate, setStartDate] = useState(() => moment(currentDate).startOf('month').format('MM-DD-YYYY'));
  const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  const [open, setOpen] = useState(false);
  const [openDownloadPcr,setOpenDownloadPcr]= useState(false);
  const [openPcr,setOpenPcr]= useState(false);
  const[openFRRReport,setOpenFFRReport]= useState(false);
  const[openFRRReportdownload,setOpenFFRReportdownload]= useState(false);
  const setDate = (data: any, type: string) => {
    try {
        if (type === 'start') {
            setStartDate(moment(data).format('MM-DD-YYYY'));
        } else {
            setEndDate(moment(data).format('MM-DD-YYYY'));
        }
    } catch (error) {
        toast.error('Error fetching Date');
    }
};

  useEffect(() => {
    const initialSearchByTitleApi=async(reporType:string)=>{
      try
        {
          setLoadData([]);
          setTableLoading(true);
          await RestorationStore.TitleDashboardSearchByTitle('','Search By Title Code');
          setLoadData(RestorationStore.TitleWiseDashboardData);
          setTableLoading(false);
        }
        catch {
          toast.error('Error fetching data');
          setTableLoading(false);
        }
    }
    if (user?.displayName === 'E1401') {
      initialSearchByTitleApi('Search By Title Code');
    }
    // eslint-disable-next-line
  }, []);
  const dataApiLoad=async ()=> {
    try
    {
      setLoadData([]);
      setTableLoading(true);
      await RestorationStore.TitleDashboardReport(startDate,endDate);
      setLoadData(RestorationStore.TitleWiseDashboardData);
      setTableLoading(false);
    }
    catch {
      toast.error('Error fetching data');
      setTableLoading(false);
    }
  }
const searchByInprogressAPI=async()=>{
  try
    {
      setLoadData([]);
      setTableLoading(true);
      await RestorationStore.TitleDashboardInProgessTitle();
      setLoadData(RestorationStore.TitleWiseDashboardData);
      setTableLoading(false);
    }
    catch {
      toast.error('Error fetching data');
      setTableLoading(false);
    }
}

const searchByTitleApi=async(reporType:string)=>{
  try
    {
      setLoadData([]);
      setTableLoading(true);
      await RestorationStore.TitleDashboardSearchByTitle(titleName,reporType);
      setLoadData(RestorationStore.TitleWiseDashboardData);
      setTableLoading(false);
    }
    catch {
      toast.error('Error fetching data');
      setTableLoading(false);
    }
}

     const CsvConvert=()=>{
    const rows: string[] = [];
    const headers = [
      'Title Name',
      'Title Code',
      'Resolution',
      'Client',
      'Start date',
      'Delivery Date',
      'Allocated Frames',
      'Approved Frames',
      'QC Rejected Frames',
      'FQA Rejected Frames',
      'CQC Rejected Frames',
      'QC Complete Percentage',
      'Estimate Hour',
      'Production Hours',
      'Quality Hours',
      'Actual Hours',
      'Efficiency Hours',
      'Title Status',
      'PCR Status',
      'FFR Status',
    ];

    rows.push(headers.join(','));
    loadData.forEach(item => {
      const row = [
        item.title_Name,
        item.title_Code,
        item.resolution,
        item.client_Name,
        item.start_date,
        item.delivery_date,
        item.allocated_Frames.toString(),
        item.approved_Frames.toString(),
        item.qC_Rejected_Frames.toString(),
        item.fqA_Rejected_Frames.toString(),
        item.cqC_Rejected_Frames.toString(),
        item.complete_Percentage,
        item.estimate_Hour.toString(),
        item.production_Hours.toString(),
        item.quality_Hours.toString(),
        item.total_Hours.toString(),
        item.total_Efficiency_Hours.toString(),
        item.titlestatus,
        item.pcrStatus,
        item.frrStatus,
      ];
      rows.push(row.join(','));
    });

    return rows.join('\n');
  }
  const handleDownload = () => {
    const csvContent = CsvConvert();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${startDate}_${endDate}_ProductivityReportByProjectName.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
  useEffect(()=>{
    //dataApiLoad();
    setReportOptions([
      { key: 1, text: 'Search By Title Code', value: 'Search By Title Code' },
      { key: 2, text: 'Date Wise', value: 'Date Wise' },
      { key: 3, text: 'Pending Title', value: 'Pending Title' },
      { key: 4, text: 'Search By Project Name', value: 'Search By Project Name' },
      { key: 5, text: 'Search By Client', value: 'Search By Client' }
    ]);
    // eslint-disable-next-line
  },[])
  const PcrGenerated=(rowdata:TitleWiseDashboard)=>{
    setOpenPcr(true)
    setOpen(true);
    setpcrData(rowdata);
  }
  const PcrDownlaod=(rowdata:TitleWiseDashboard)=>{
    setOpenDownloadPcr(true)
    setOpen(true);
    setpcrData(rowdata);
  }
  const ffrhandle=(rowdata:TitleWiseDashboard)=>{
    if(rowdata.frrStatus==="FRR Pending"){
      setOpenDownloadPcr(false);
      setOpenFFRReport(true);
      setOpen(true);
      setpcrData(rowdata);
    }
    else if(rowdata.frrStatus==="FRR Completed"){
      setOpenDownloadPcr(false);
      setOpenFFRReportdownload(true);
      setOpen(true);
      setpcrData(rowdata);
    }
  }
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitleName(event.target.value);
  };
  return (
    <>
      <>
          <div className="title-wise-table" style={{paddingRight: '20px'}}>
          {user?.customerName === 'PCPLCRM' ?  (<Header> Restoration Status Report</Header>):(
            <Header>Title Dashboard Report</Header>)}
            <div className="row" style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px', marginBottom: '20px' }}>
            <h4 style={{ marginRight: '20px' }}>Report Options :</h4>
            <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px', marginBottom: '20px', marginRight: '20px' }}>
              <Select
                placeholder="Select Report Option"
                selection
                search
                clearable
                options={reportOptions}
                value={selectedReportType}
                onChange={(e:any, data:any) => { setSelectedReportType(data.value); }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
              {selectedReportType === 'Date Wise' ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px', marginRight: '20px' }}>
                    <h4>From Date</h4>
                    <DatePicker
                      placeholderText="From Date"
                      value={
                        startDate
                          ? PivotStore.dateFormat(
                            moment(startDate).format('MM-DD-YYYY'),
                          )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      // maxDate={moment().toDate()}
                      scrollableYearDropdown
                      onChange={(date) => setDate(date, 'start')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px', marginRight: '20px' }}>
                    <h4>To Date</h4>
                    <DatePicker
                      placeholderText="To Date"
                      value={
                        endDate
                          ? PivotStore.dateFormat(
                            moment(endDate).format('MM-DD-YYYY'),
                          )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      maxDate={moment(startDate).add(60, 'days').toDate()}
                      scrollableYearDropdown
                      onChange={(date) => setDate(date, 'end')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                  </div>
                  <Button
                    primary
                    onClick={dataApiLoad}
                    style={{ display: 'flex', alignItems: 'center', paddingRight: '20px', paddingBottom: '10px', marginRight: '20px' }}
                  >
                    View Report
                  </Button>
                  {loadData.length !== 0 && (
                    <Button onClick={handleDownload} style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                      <Icon className="download" />
                    </Button>
                  )}
                </div>
              ) : selectedReportType === 'Search By Title Code' || selectedReportType === 'Search By Project Name' || selectedReportType === 'Search By Client' ? 
              (
                <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <h4>Search By</h4>
                  <FormField style={{ paddingLeft: '20px', marginRight: '20px' }}>
                    <Input type="text" value={titleName} onChange={handleTitleChange} />
                  </FormField>
                  <Button
                    primary
                    onClick={()=>searchByTitleApi(selectedReportType)}
                    style={{ display: 'flex', alignItems: 'center', paddingRight: '20px', paddingBottom: '10px' }}
                  >
                    Search
                  </Button>
                </div>
              ) : selectedReportType === 'Pending Title' ? (
                <div>
                  <Button
                    primary
                    onClick={searchByInprogressAPI}
                    style={{ display: 'flex', alignItems: 'center', paddingRight: '20px', paddingBottom: '10px' }}
                  >
                    View Report
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
          <div style={{maxWidth:'95%',paddingRight: '20px'}}>
          <Table>
            <TableHeader>
            <TableRow>
              <TableHeaderCell>Title Name</TableHeaderCell>
              <TableHeaderCell>Title Code</TableHeaderCell>
              <TableHeaderCell>Resolution</TableHeaderCell>
              <TableHeaderCell>Client</TableHeaderCell>
              <TableHeaderCell>Start date</TableHeaderCell>
              <TableHeaderCell>Delivery Date</TableHeaderCell>
              <TableHeaderCell>Allocated Frames</TableHeaderCell>
              <TableHeaderCell>Approved Frames</TableHeaderCell>
              {(user?.displayName === 'E1401' || selectedReportType === 'Search By Title Code' || selectedReportType === 'Pending Title') && (
                <>
                  <TableHeaderCell>QC Rejected Frames</TableHeaderCell>
                  <TableHeaderCell>FQA Rejected Frames</TableHeaderCell>
                  <TableHeaderCell>CQC Rejected Frames</TableHeaderCell>
                </>
              )}
              <TableHeaderCell>QC Complete Percentage</TableHeaderCell>
              <TableHeaderCell>Estimate Hour</TableHeaderCell>
              <TableHeaderCell>Production Hours</TableHeaderCell>
              <TableHeaderCell>Quality Hours</TableHeaderCell>
              <TableHeaderCell>Actual Hours</TableHeaderCell>
              <TableHeaderCell>Efficiency Hours</TableHeaderCell>
              <TableHeaderCell>Title Status</TableHeaderCell>
              {user?.customerName !== 'PCPLCRM' && (
              <>
              <TableHeaderCell>PCR Report Action</TableHeaderCell>
              <TableHeaderCell>FRR Report Action</TableHeaderCell>   </> )}           
              </TableRow>
            
            </TableHeader>
            <TableBody>
            { selectedReportType ==='' &&  (
              <TableRow>
                  <TableCell colSpan={15} textAlign="center"> 
                  Kindly select any one report type
                  </TableCell>
              </TableRow>)}

            {tableLoading ===true && selectedReportType !=='' && titleName !=='' &&  ( 
              <TableRow>
                  <TableCell colSpan={15} textAlign="center"> 
                  <Loader active inline='centered' > Please wait, this will take a few minutes... </Loader>
                  </TableCell>
              </TableRow>)}
              {tableLoading ===true && selectedReportType !=='' && titleName ==='' &&  ( 
              <TableRow>
                  <TableCell colSpan={15} textAlign="center"> 
                    Please Enter Valid input and Click search Button
                  </TableCell>
              </TableRow>)}
              {loadData.length===0 && tableLoading ===false && ( 
              <TableRow>
                  <TableCell colSpan={15} textAlign="center"> Currently Data not Avaialabe</TableCell>
              </TableRow>)}
              {loadData.map((item,index)=>(
                <TableRow key={index}>
                  <TableCell>{item.title_Name}</TableCell>
                  <TableCell>{item.title_Code}</TableCell>
                  <TableCell>{item.resolution}</TableCell>
                  <TableCell>{item.client_Name}</TableCell>
                  <TableCell>{item.start_date}</TableCell>
                  <TableCell>{item.delivery_date}</TableCell>
                  <TableCell>{item.allocated_Frames}</TableCell>
                  <TableCell>{item.approved_Frames}</TableCell>
                  {(user?.displayName === 'E1401' || selectedReportType === 'Search By Title Code' || selectedReportType === 'Pending Title') && (
                    <>
                      <TableCell>{item.qC_Rejected_Frames}</TableCell>
                      <TableCell>{item.fqA_Rejected_Frames}</TableCell>
                      <TableCell>{item.cqC_Rejected_Frames}</TableCell>
                    </>
                  )}
                  <TableCell>{item.complete_Percentage}</TableCell>
                  <TableCell>{item.estimate_Hour}</TableCell>
                  <TableCell>{item.production_Hours}</TableCell>
                  <TableCell>{item.quality_Hours}</TableCell>
                  <TableCell>{item.total_Hours}</TableCell>
                  <TableCell>{item.total_Efficiency_Hours}</TableCell>
                  <TableCell>{item.titlestatus}</TableCell>
                  {user?.customerName !== 'PCPLCRM' && (
              <>
                  <TableCell style={{ alignItems: 'center' }}> 
                    {
                      item.pcrStatus==='-' ? "-" 
                      :item.pcrStatus.includes("PCR Pending") ? 
                      <Button className="ui inverted green button" style={{ display: 'flex', alignItems: 'center' }} onClick={()=>PcrGenerated(item)} size='mini'>
                        <Icon className="external alternate" style={{ display: 'flex'}}/>PCR</Button> 
                      :item.pcrStatus.includes("PCR Completed") ?
                    
                        <Button className="ui button" onClick={()=>PcrDownlaod(item)}><Icon className='download'/></Button>
                    
                      : "N/A"
                  }
                </TableCell>
                <TableCell style={{ alignItems: 'center' }}>
                {
                  item.frrStatus==='-' ? "-" 
                  :item.frrStatus.includes("FRR Pending") ? 
                  <Button className="ui inverted green button" style={{ display: 'flex', alignItems: 'center' }} onClick={()=>ffrhandle(item)} size='mini'>
                    <Icon className="external alternate" style={{ display: 'flex'}} />FRR</Button> 
                  :item.frrStatus.includes("FRR Completed") ?
                    <Button className="ui button" onClick={()=>ffrhandle(item)}><Icon className='download'/></Button>
                  : "N/A"
                  }
                </TableCell>
</>)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </div>
          </div>
          </>
          <div>
            {open && (
              
              <Modal open={open}  size={'fullscreen'} scrolling>
                <Modal.Content style={{ overflowY: 'auto', maxHeight: '90vh' }}>
                {pcrData !== null && openPcr === true && (<PCRCreate rowdata={pcrData}/>)}
                {pcrData !== null && openDownloadPcr === true && (<PCRDownload rowdata={pcrData}/>)}
                {pcrData !== null && openFRRReportdownload === true && (<FRRreport rowdata={pcrData}/>)}
                {pcrData !== null && openFRRReport === true &&(<FrrCreate rowdata={pcrData}/>)}
              </Modal.Content>
            </Modal>
            )}
          
          </div>
    </>
  );
}

export default TitleDashboardReport;
